import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from './endpoint.config.service';
import { ConnectionService } from './connection.service';
import { debug } from 'console';

@Injectable({
  providedIn: 'root'
})
export class UserService extends ConnectionService {
  //currentLocationId: any;
  constructor(http: HttpClient, private configs: ConfigService) {
    super(http);
    //if (this.currentLocationId == undefined && sessionStorage.getItem("company") != undefined)
    //  this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
  }

  getCurrentUser(sucFun, errFun) {
    this.CallApi("get", this.configs.getAppApiUrl("GET_CURRENT_USER"), {}, null, (res) => {
      sucFun(res);
    }, (err) => {
      errFun(err);
    });
  }

  activateUser(userId, sucFun, errFun) {
    let currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    this.CallApi("put", this.configs.getAppApiUrl("ACTIVATE_USER").replace("{{currentLocationId}}", currentLocationId).replace("{{userId}}", userId), {}, null, (res) => {
      sucFun(res);
    }, (err) => {
      errFun(err);
    });
  }

  deactivateUser(userId, sucFun, errFun) {
    let currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    this.CallApi("put", this.configs.getAppApiUrl("DEACTIVATE_USER").replace("{{currentLocationId}}", currentLocationId).replace("{{userId}}", userId), {}, null, (res) => {
      sucFun(res);
    }, (err) => {
      errFun(err);
    });
  }

  setUserOtpEmail(email, sucFun, errFun) {
    this.CallApi("put", this.configs.getAppApiUrl("SET_USER_OTP_EMAIL") + `?email=${email}`, null, null, (res) => {
      sucFun(res);
    }, (err) => {
      errFun(err);
    });
  }

  getUserOtpEmail(sucFun, errFun) {
    this.CallApi("get", this.configs.getAppApiUrl("GET_USER_OTP_EMAIL"), null, null, (res) => {
      sucFun(res);
    }, (err) => {
      errFun(err);
    });
  }

}
